<template>
  <main class="narrow-view">
    <h1 class="view-full-span">
      {{ $t('password-reset.heading') }}
    </h1>

    <PasswordResetRequestForm />
  </main>
</template>

<script lang="ts" setup>
import PasswordResetRequestForm from '@/components/forms/PasswordResetRequestForm.vue'
</script>
